import { Pipe, PipeTransform } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { BaseService } from '../shared/services/base.service';
import { Observable } from 'rxjs/internal/Observable';

@Pipe({
    name: 'cachableSecure',
    standalone: false
})
export class CachableSecurePipe implements PipeTransform {

    constructor(
            private baseService:BaseService
         ) { }

    transform(url): Observable<SafeUrl> {
        return this.baseService.getCachedFileByUrl(url);
    }

}